import { useDispatch } from "react-redux";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import {
  handleParameterCreate,
  handleParameterOutputCreate,
} from "../../../abstract/redux/slice/structureSlice";
import { ButtonDefault } from "../../ui/buttons/ButtonDefault";
import styles from "./CanvasElementButton.module.scss";

function CanvasElementButton({ node, isGlobal }) {
  const dispatch = useDispatch();

  const _id = nodeUtils.getID(node);

  const handleAddMainParameterLogic = () => {
    dispatch(handleParameterCreate(_id));
  };

  const handleAddMainOutputParameterLogic = () => {
    dispatch(handleParameterOutputCreate(_id));
  };

  const getClass = () => {
    return `${styles["button"]}`;
  };

  return (
    <div className={getClass()}>
      {isGlobal ? (
        <ButtonDefault text={"add global\nparameter"} handler={handleAddMainParameterLogic} />
      ) : (
        <ButtonDefault text={"add input\nparameter"} handler={handleAddMainParameterLogic} />
      )}
      {!isGlobal && (
        <ButtonDefault text={"add output\nparameter"} handler={handleAddMainOutputParameterLogic} />
      )}
    </div>
  );
}

export default CanvasElementButton;
